import { TYPE_ITEM } from './node-attributes';

export const cutUncheckedNodes = (tree) => {
  const childrenList = [];

  if (tree) {
    tree.forEach((node) => {
      if (node.checked) childrenList.push(node);
      else if (node.type === TYPE_ITEM.FOLDER && node.children) {
        node.children = cutUncheckedNodes(node.children);

        if (node.children.length > 0) childrenList.push(node);
      }
    });
  }

  return childrenList;
};
